export default __webpack_public_path__ + "static/media/illustration-australia.090e2b81.svg";